import React, { useState } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { Link } from "react-router-dom";
const Plans = () => {
  const [isActivated, setIsActivated] = useState(true);
  const [fullWidthWrapper, setFullWidthWrapper] = useState();
  const handleToggle = () => {
    setIsActivated(!isActivated);
    setFullWidthWrapper(isActivated ? "fullwrapper" : "");
  };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullWidthWrapper}>
        <Header onclick={handleToggle} />
        <div id="page_wrapper" className="py-3">
          <div className="card p-3 border-light-subtle ">
            <ul className="breadcrumb m-0">
              <li>
                <Link to="/dashboard">
                  <i className="bi bi-people"></i> Dashboard
                </Link>
              </li>

              <li>
                <span className="breadcrumb_slash">/</span> <i className="bi bi-app-indicator mx-2"></i> Plans
              </li>
            </ul>
          </div>
        </div>

        <div className="column px-3">
          <div className="card p-2 border-light-subtle mb-2">
            <div className="row p-3">
              <div className="col-lg-6">
                <label className="fw-bold " htmlFor="" style={{ fontSize: "27px", lineHeight: "20px", marginBottom: "0px" }}>
                  Plans
                </label>
              </div>
              <div className="col-lg-6 d-flex justify-content-end">
                <div className="w-50 px-2">
                  <button className="btn  py-0 fs-12 fw-600">Monthly</button>
                  <button className="btn  py-0 fs-12 fw-600">Yearly</button>
                </div>
              </div>
            </div>
          </div>
          <div className="card p-2 border-light-subtle">
            <div className="row p-4">
              <div className="col-lg-2">
                <div className="common_form ">
                  <span className="text-black fs-13">Plan A</span>
                  <label className="fw-bolder " htmlFor="" style={{ fontSize: "33px", lineHeight: "33px", marginBottom: "5px" }}>
                    $10
                  </label>
                  <span className="text-grey fs-12">Per Month</span>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="common_form lh-20">
                  <ul>
                    <li>Branding</li>
                    <li>Source Management</li>
                    <li>Data hosting</li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="common_form lh-20 ">
                  <ul>
                    <li>Survey Scripting</li>
                    <li>End Page Management</li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4 align-self-center">
                <div className="common_form lh-20">
                  <button className="btn btn-success px-4 fs-12 fw-600">Unlock</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Plans;
